import { useEffect, useRef } from "react";

const COLORS = ["#E8B4B8", "#D6CBEB", "#F2C9CF", "#C9D6C0", "#EFC9A8"];

export const PetalsCanvas = ({ className = "" }) => {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    let raf;
    let w, h;
    const petals = Array.from({ length: 26 }, () => ({
      x: Math.random(),
      y: Math.random(),
      s: 5 + Math.random() * 8,
      vy: 0.0004 + Math.random() * 0.0008,
      vx: (Math.random() - 0.5) * 0.0004,
      r: Math.random() * Math.PI * 2,
      vr: (Math.random() - 0.5) * 0.02,
      c: COLORS[Math.floor(Math.random() * COLORS.length)],
      o: 0.35 + Math.random() * 0.35,
    }));

    const resize = () => {
      w = canvas.width = canvas.offsetWidth;
      h = canvas.height = canvas.offsetHeight;
    };
    resize();
    window.addEventListener("resize", resize);

    const draw = () => {
      ctx.clearRect(0, 0, w, h);
      for (const p of petals) {
        p.y += p.vy;
        p.x += p.vx + Math.sin(p.y * 6) * 0.0003;
        p.r += p.vr;
        if (p.y > 1.05) { p.y = -0.05; p.x = Math.random(); }
        ctx.save();
        ctx.translate(p.x * w, p.y * h);
        ctx.rotate(p.r);
        ctx.globalAlpha = p.o;
        ctx.fillStyle = p.c;
        ctx.beginPath();
        ctx.ellipse(0, 0, p.s, p.s * 0.55, 0, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      }
      raf = requestAnimationFrame(draw);
    };
    draw();
    return () => { cancelAnimationFrame(raf); window.removeEventListener("resize", resize); };
  }, []);

  return <canvas ref={ref} className={`pointer-events-none absolute inset-0 h-full w-full ${className}`} />;
};
